import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-gray-50 pt-16 pb-8 border-t" data-id="element-328">
      <div className="container mx-auto px-4" data-id="element-329">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-330">
          <div className="col-span-2 md:col-span-1" data-id="element-331">
            <Link to="/" className="text-xl font-bold tracking-tighter block mb-4" data-id="element-332">
              <span style={{
              color: '#ff6b6b',
              fontWeight: 700
            }} data-id="element-333">
                Fling
              </span>
              <span data-id="element-334">Link</span>
            </Link>
            <p className="text-sm text-muted-foreground mb-4" data-id="element-335">
              Low pressure. Clear vibes.
              <br data-id="element-336" />
              No swiping. No feed.
            </p>
            <div className="text-xs text-muted-foreground" data-id="element-337">
              © {new Date().getFullYear()} FlingLink
            </div>
          </div>

          <div data-id="element-338">
            <h4 className="font-semibold mb-4" data-id="element-339">Product</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-340">
              <li data-id="element-341">
                <Link to="/pricing" className="hover:text-primary" data-id="element-342">
                  Pricing
                </Link>
              </li>
              <li data-id="element-343">
                <Link to="/how-it-works" className="hover:text-primary" data-id="element-344">
                  How it works
                </Link>
              </li>
              <li data-id="element-345">
                <Link to="/help/install-flinglink" className="hover:text-primary" data-id="element-346">
                  Install PWA
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-347">
            <h4 className="font-semibold mb-4" data-id="element-348">Safety</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-349">
              <li data-id="element-350">
                <Link to="/safety" className="hover:text-primary" data-id="element-351">
                  Safety Center
                </Link>
              </li>
              <li data-id="element-352">
                <Link to="/privacy" className="hover:text-primary" data-id="element-353">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-354">
                <Link to="/terms" className="hover:text-primary" data-id="element-355">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-356">
            <h4 className="font-semibold mb-4" data-id="element-357">Support</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-358">
              <li data-id="element-359">
                <Link to="/help" className="hover:text-primary" data-id="element-360">
                  Help Center
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center text-xs text-muted-foreground pt-8 border-t" data-id="element-361">
          <p data-id="element-362">Made just for You. Not a Dating App.</p>
        </div>
      </div>
    </footer>;
}